import type { ReactNode } from "react";

/** A standalone number (price, code, count) in the pixel face. Sentences keep the body face: wrap only the number. */
export function Num({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={className ? `num ${className}` : "num"}>{children}</span>;
}
